var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginPatternLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 526,
    height: 604,
    viewBox: "0 0 526 604",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_215)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 526,
    height: 604,
    fill: "#F5F5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.4185 462.098C62.1684 451.826 109.123 441.555 109.123 441.555C167.082 437.887 239.715 403.405 239.715 403.405C293.272 376.259 314.564 357.313 351.965 330.772C389.366 304.232 423.956 253.738 441.471 225.859C465.869 187.026 475.954 162.03 489.893 118.01C503.833 73.9904 513.371 26.3024 513.371 -41.9282C513.371 -110.159 510.436 -98.4202 510.436 -98.4202C446.607 -98.4202 -139.589 -98.4203 -198.282 -98.4203L-198.282 446.691L-123.448 455.495L-57.4185 462.098Z",
    fill: "#8AD657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-202.428 534.137L-210.134 532.28L-224.467 -40.2985C-183.675 -22.6652 -65.8218 31.5446 37.7999 87.062L115.229 141.847C248.48 239.634 275.966 364.919 238.052 456.552C200.12 548.227 95.9247 608.374 -39.1167 574.524C-107.898 557.283 -149.442 546.874 -173.069 540.958C-184.882 538.001 -192.218 536.166 -196.24 535.163C-198.246 534.662 -199.438 534.365 -199.948 534.24C-200.068 534.21 -200.176 534.184 -200.247 534.167C-200.264 534.163 -200.301 534.155 -200.343 534.145C-200.369 534.139 -200.437 534.125 -200.482 534.116C-200.593 534.095 -201.518 534.004 -202.335 534.045C-202.366 534.076 -202.397 534.107 -202.428 534.137Z",
    stroke: "#0173BC",
    strokeWidth: 11.7386
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 526,
    height: 604,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPatternLeft);
export default __webpack_public_path__ + "static/media/login-pattern-left.e4820087d4eef6db5a6e8c33e3819e16.svg";
export { ForwardRef as ReactComponent };